import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_RET006_Request as ReferRequest,
  IAPI_RET006_Response as ReferResponse,
} from "../../../type/apiType";

// 退職手当金請求書の取り下げ参照
// API仕様書_退職者
const httpAPI_RET006 = async (param: ReferRequest): Promise<ReferResponse> => {
  let res = await http.post(ApiUrl.API_RET006, {
    ...param,
  });
  return res.data;
};

export { httpAPI_RET006 };
